import { convertToHtml } from 'components/blog/blog-content/blog-content';
import LandingSection from 'components/landing/components/landing-section';
import propTypes from 'prop-types';
import styles from 'styles/CustomCompanyContent.module.scss';
import { useMemo } from 'react';
import { useTranslations } from 'next-intl';

const CustomContent = ({ content }) => {
    if (content === '' || content === null) {
        return null;
    };

    const t = useTranslations('custom-content');
    const imageAlt = t('image-alt');

    // Use same function as in blog-content.js
    const htmlContent = useMemo(
        () => convertToHtml(content, imageAlt),
        [content]
    );

    return (
        <LandingSection>
            <div className={styles.content_body}>
                { htmlContent }
            </div>
        </LandingSection>
    );
};

CustomContent.propTypes = {
    content: propTypes.string
};

export default CustomContent;
